import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  buttonText: {
    id: 'frontbucket.pipelines.components.deploymentSummaryAiAssistant.buttonText',
    description:
      'The message on the deployment summary AI assistant button on deployment modal',
    defaultMessage: 'Summarize',
  },
  error: {
    id: 'frontbucket.pipelines.components.deploymentSummaryAiAssistant.error',
    description:
      'The error message show when deployment summary AI assistant fails',
    defaultMessage: 'Failed to generate a deployment summary.',
  },
});
